import {ObjectId} from 'bson';

export const OBJECT_ID_RE = /^[0-9a-f]{24}$/i;

/**
 * Will check to see if a string looks like a mongo ObjectId.
 * @param  {String}  str Thing to be checked.
 * @return {Boolean}     True IFF this object looks like a mongo ObjectId.
 *
 * Note: Prefer this function over isMongoId!!
 */
export function isObjectId(str: any): boolean {
  return OBJECT_ID_RE.test(String(str));
}

/**
 * FORCE an input value to be coerced to an ObjectId. This will throw if this isn't the case, so be sure that either:
 *
 *   a: Throwing is ok in the calling context, like in a async function, or
 *   b: The value has been externally validated, and if this threw, it would indicate a programmer's error.
 *
 * @param   {*}        val The input value that's about to be coerced to an ObjectId.
 * @returns {ObjectId} The ObjectId.
 */
export function asObjectId(val: any): ObjectId {
  const str = String(val);
  if (!OBJECT_ID_RE.test(str)) {
    throw new Error('Not an id: ' + str);
  }
  return new ObjectId(str);
}
